import styled, { css } from 'styled-components'

import { MEDIA } from 'utils/constants'

// Media query
const { MOBILE_UP, MOBILE } = MEDIA

export const ModalBox = styled.div`
  position: fixed;
  float: left;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: ${props => props.visible ? 1073 : -100};
  display: flex;
  flex-direction: column;
  overflow: hidden !important;
  width: 752px;
  max-width: 95vw;
  max-height: max(95vh);
  background-color: var(--the-white);
  transition: all 0.12s ease-in;
  opacity: ${props => props.visible ? 1 : 0};
  border-radius: 2.4rem;
  padding: 16px;

  font-family: var(--primary-font);
  color: var(--gray-5);
  text-align: center;

  @media screen and ${MOBILE} {
    width: 100vw;
    height: 100vh;
    min-width: 100vw;
    min-height: 100vh;
    max-width: unset;
    max-height: unset;
    border-radius: 12px, 12px, 0px, 0px;
    margin-top: 16px;
  }

  @media screen and ${MOBILE_UP} {
    min-height: ${({ type }) => type === 'info' ? 'auto' : '270px'};
    ${props => props.modalHeight && `height:${props.modalHeight}; min-height:unset;`}
    padding: 24px;
    max-width: 90vw;
  }
`

export const ModalBody = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 5px 5px 0 0;
  overflow: hidden;

  @media screen and ${MOBILE_UP} {
    width: ${props => props.contentWidth ? `${props.contentWidth}px` : '100%'};
  }

`

export const ModalTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0.96px;
  margin-top: 16px;
  color: var(--gray-2);

  @media screen and ${MOBILE} {
    font-weight: 600;
    font-size: 16px;
    margin-top: 16px;
  }
`

export const ModalSubtitle = styled(ModalTitle)`
  font-size: 20px;
  line-height: 25px;
  margin-top: 0;

  @media screen and ${MOBILE_UP} {
    font-size: 18px;
  }
`

export const ModalContent = styled.div`
  font-size: 13px;
  font-weight: 400;
  line-height: 145%;
  width: 100%;
  font-family: var(--primary-font);
  overflow: auto;
  position: relative;
  a {
    color: ${props => props.type === 'info' ? 'var(--the-white);' : 'var(--cobasi-blue-light-8);'}
  }

  @media screen and ${MOBILE} {
    font-size: 13px;
  }
`

export const ModalBackdrop = styled.span`
  display: ${props => props.visible ? 'flex' : 'none'};
  align-items:center;
  justify-content:center;
  content: '';
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1072;
`

export const ModalFooter = styled.footer`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px auto;
  flex-direction: column;

  @media screen and ${MOBILE_UP} {
    width: ${props => props.contentWidth ? `${props.contentWidth}px` : '100%'};
    justify-content: center;
  }
`

export const CancelButton = styled.button`
  width: auto;
  height: 48px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ outlineCancelButton }) => outlineCancelButton ? 'var(--cobasi-blue-light-8)' : 'var(--the-white)'};
  font-size: 16px;
  font-weight: 600;
  font-family: var(--primary-font);
  cursor: pointer;
  background-color: ${({ outlineCancelButton }) => outlineCancelButton ? 'var(--the-white)' : 'var(--cobasi-blue-light-8)'};
  border: ${({ outlineCancelButton }) => outlineCancelButton ? '1px solid var(--cobasi-blue-light-8)' : 'none'};
  border-radius: 8px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin-top: 16px;

  ${({ fullButton }) => fullButton && css`
    width: 100%;
    padding: 0px;
  `}

   > :first-child {
      margin-top: 16px;
    }

  @media screen and ${MOBILE} {
    width: 100%;
    height: 40px;
  }
`

export const ConfirmButton = styled(CancelButton)`
  background-color: var(--cobasi-blue-light-8);
  color: var(--the-white);
  border-radius: 8px;

  @media screen and ${MOBILE} {
    width: 100%;
  }
`
